import type { FC } from 'react'
import { useState } from 'react'
import styled from '@emotion/styled'

import Loader from '@segment/matcha/components/Loader'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor'

const Description = () => {
  const scrollTo = useScrollToAnchor(`connect-with-sales`, -96)
  return (
    <>
      Twilio Segment collects events from your web and mobile apps and unifies them into a complete view of the
      customer. Explore the interactive demo to see how Segment helps teams collect, clean, and activate data, or
      {` `}
      <StyledAnchor
        onClick={(e) => {
          e.preventDefault()
          scrollTo()
        }}
      >
        connect with sales
      </StyledAnchor>
      {` `}
      to learn more.
    </>
  )
}

const copy = {
  heading: `Twilio Segment: Interactive Product Demo`,
  description: <Description />,
}

const Hero: FC = () => {
  const [loading, setLoading] = useState(true)
  return (
    <Wrapper>
      <StyledHero variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <IframeWrapper>
            {loading && <StyledLoader size="xlarge" />}

            <Iframe title="Product Tour" src="https://twilio.navattic.com/5z30d5h" onLoad={() => setLoading(false)} />
          </IframeWrapper>
        </HeroRecipe.Contents>
      </StyledHero>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHero = styled(HeroBase)`
  max-width: unset;
`

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1340px;
  padding-bottom: 56.25%;
`

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 90px);
`

const StyledAnchor = styled.a`
  cursor: pointer;
`

const StyledLoader = styled(Loader)`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export default Hero
